import React from 'react';
import { CategoryFormData } from '../../types';
import { PRIORITY_OPTIONS } from '../../constants';
import CustomDropdown from '../../../../UI/CustomDropdown';
import sidePanelStyles from '../../../../../styles/SidePanel.module.css';
import customDropdownStyles from '../../../../../styles/CustomDropdown.module.css';

interface BasicInfoTabProps {
  formData: CategoryFormData;
  onInputChange: (field: string, value: any) => void;
}

const BasicInfoTab: React.FC<BasicInfoTabProps> = ({ formData, onInputChange }) => {
  return (
    <div className={`${sidePanelStyles.tabContent} ${sidePanelStyles.active}`}>
      <div className={sidePanelStyles.formGroup}>
        <label className={sidePanelStyles.formLabel}>
          Scheme Name <span className={sidePanelStyles.required}>*</span>
        </label>
        <input
          type="text"
          className={sidePanelStyles.formControl}
          
          value={formData.name}
          onChange={(e) => onInputChange('name', e.target.value)}
          required
        />
      </div>
      <div className={sidePanelStyles.formGroup}>
        <label className={sidePanelStyles.formLabel}>
          Description <span className={sidePanelStyles.required}>*</span>
        </label>
        <textarea
          className={sidePanelStyles.formControl}
          rows={3}
          value={formData.description}
          onChange={(e) => onInputChange('description', e.target.value)}
          required
        />
      </div>
      <div className={sidePanelStyles.formGroup}>
        <label className={sidePanelStyles.formLabel}>
          Priority Level <span className={sidePanelStyles.required}>*</span>
        </label>
        <CustomDropdown
          options={PRIORITY_OPTIONS}
          value={formData.priority}
          onChange={(value) => onInputChange('priority', Array.isArray(value) ? value[0] : value)}
          placeholder="Select Priority Level"
          size="md"
          variant="outlined"
          className={customDropdownStyles.sizeFull}
        />
      </div>
    </div>
  );
};

export default BasicInfoTab;